<div class="min-h-screen text-sm dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <div class="flex flex-col md:flex-row md:items-end justify-between mb-6 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">
        Monitor โควต้าจอดฟรี
      </h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        ลาน:
        <span class="font-bold text-amber-600 dark:text-amber-400">{{ selectedSiteName || '— เลือกลาน —' }}</span>
      </p>
      <p class="text-xs text-slate-400 mt-1">
        ดูการใช้จริงจากบัตรที่สร้างแล้ว · แสดงเฉพาะ Client ที่ใช้มาก (Top 10)
      </p>
    </div>
    <div class="flex flex-wrap gap-2">
      <a routerLink="/card-quota/free-parking-cards"
        class="px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 font-bold inline-flex items-center gap-2">
        <span class="material-icons text-[18px]">credit_card</span>
        ไปหน้ารายการบัตร
      </a>
      <button type="button" (click)="onRefresh()" [disabled]="!selectedSiteId || isLoading()"
        class="px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 font-bold flex items-center gap-2">
        <span class="material-icons text-[18px]">refresh</span>
        โหลดใหม่
      </button>
    </div>
  </div>

  <div *ngIf="!selectedSiteId && !isLoading()"
    class="rounded-2xl border border-dashed border-amber-300 bg-amber-50/50 p-8 text-center">
    <p class="font-bold text-slate-700">เลือกลานจากแถบด้านข้างก่อน</p>
  </div>

  <app-pss-loading *ngIf="isLoading()"></app-pss-loading>

  <ng-container *ngIf="selectedSiteId && !isLoading() && dashboard() as dash">

    <div *ngIf="hasGroup && scope as sc"
      class="mb-4 text-xs text-slate-500 flex flex-wrap gap-2 items-center">
      <span class="font-bold text-slate-700 dark:text-slate-200">{{ sc.groupName || ('กลุ่ม #' + sc.groupId) }}</span>
      <span class="px-2 py-0.5 rounded-full bg-amber-100 text-amber-800 font-bold">{{ groupTypeLabel(sc.groupType) }}</span>
      <span>· กรองตามขอบเขตกลุ่ม</span>
    </div>

    <!-- KPI -->
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-6">
      <div class="rounded-2xl border border-amber-200/80 bg-amber-50/70 dark:bg-amber-950/20 p-4 shadow-sm">
        <p class="text-xs font-bold text-amber-800/70 uppercase">บัตรจอดฟรีที่ใช้งาน</p>
        <p class="text-3xl font-black text-amber-700 dark:text-amber-300 mt-1">{{ dash.activeFreeCardCount }}</p>
        <p class="text-[11px] text-amber-800/60 mt-1">นับจาก parking_card ที่ยังไม่ลบ</p>
      </div>
      <div class="rounded-2xl border border-slate-100 dark:border-slate-800 bg-white/95 dark:bg-slate-900/95 p-4 shadow-sm">
        <p class="text-xs font-bold text-slate-400 uppercase">ใช้โควต้าลานแล้ว</p>
        <p class="text-3xl font-black text-slate-800 dark:text-slate-100 mt-1">
          {{ totalSiteUsed }}
          <span class="text-base font-bold text-slate-400">/ {{ totalSiteApproved }}</span>
        </p>
        <div class="mt-3 h-2.5 rounded-full bg-slate-100 dark:bg-slate-800 overflow-hidden">
          <div class="h-full rounded-full transition-all"
            [ngClass]="usageBarClass(overallUsedPercent)"
            [style.width.%]="overallUsedPercent"></div>
        </div>
        <p class="text-[11px] text-slate-400 mt-1">{{ overallUsedPercent }}% ของอนุมัติลาน</p>
      </div>
      <div class="rounded-2xl border border-emerald-100 dark:border-emerald-900/40 bg-emerald-50/50 dark:bg-emerald-950/20 p-4 shadow-sm">
        <p class="text-xs font-bold text-emerald-700/80 uppercase">คงเหลือ (ตามบัตรออก)</p>
        <p class="text-3xl font-black text-emerald-700 mt-1">{{ totalSiteRemainingByCards }}</p>
        <p class="text-[11px] text-emerald-700/60 mt-1">อนุมัติ − ออกบัตรแล้ว</p>
      </div>
    </div>

    <!-- Alerts -->
    <div *ngIf="dash.nearFullAlerts.length"
      class="mb-6 rounded-2xl border border-rose-200/70 bg-rose-50/40 dark:bg-rose-950/20 dark:border-rose-900/40 p-4">
      <p class="font-extrabold text-rose-800 dark:text-rose-200 mb-2 flex items-center gap-1">
        <span class="material-icons text-[18px]">warning</span>
        ใกล้เต็ม / เหลือน้อย
      </p>
      <ul class="grid grid-cols-1 md:grid-cols-2 gap-2">
        <li *ngFor="let a of dash.nearFullAlerts"
          class="rounded-xl border px-3 py-2 text-xs font-semibold flex justify-between gap-2"
          [ngClass]="alertClass(a)">
          <span>{{ a.label }} · {{ a.vehicleTypeName || a.vehicleTypeId }}</span>
          <span>{{ a.usedPercent | number:'1.0-0' }}% · เหลือ {{ a.remaining }}</span>
        </li>
      </ul>
    </div>

    <div class="grid grid-cols-1 xl:grid-cols-2 gap-6">

      <!-- Chart: site usage by vehicle type -->
      <section class="rounded-2xl border border-slate-100 dark:border-slate-800 bg-white/95 dark:bg-slate-900/95 shadow-xl p-5">
        <div class="mb-4">
          <h2 class="text-lg font-extrabold text-slate-800 dark:text-slate-100">การใช้โควต้าลาน</h2>
          <p class="text-xs text-slate-400 mt-0.5">ตามประเภทรถ · แถบ = สัดส่วนบัตรที่ออกแล้ว / อนุมัติ</p>
        </div>

        <div *ngIf="dash.siteQuotas.length === 0" class="py-12 text-center text-slate-400">
          ยังไม่มีโควต้าลาน
          <div class="mt-3">
            <a routerLink="/system-settings/site-free-quota" class="text-amber-600 font-bold text-sm hover:underline">
              ไปตั้งโควต้าลาน
            </a>
          </div>
        </div>

        <div *ngIf="dash.siteQuotas.length" class="space-y-4">
          <div *ngFor="let row of dash.siteQuotas; trackBy: trackSite">
            <div class="flex items-end justify-between gap-2 mb-1.5">
              <p class="font-bold text-slate-800 dark:text-slate-100">
                {{ row.vehicleTypeName || ('ประเภท #' + row.vehicleTypeId) }}
              </p>
              <p class="text-xs font-mono text-slate-500 shrink-0">
                {{ row.quotaUsed }} / {{ row.quotaApproved }}
                <span class="font-bold"
                  [ngClass]="siteUsedPercent(row) >= 90 ? 'text-rose-600' : (siteUsedPercent(row) >= 70 ? 'text-amber-600' : 'text-emerald-600')">
                  ({{ siteUsedPercent(row) }}%)
                </span>
              </p>
            </div>
            <div class="h-4 rounded-full bg-slate-100 dark:bg-slate-800 overflow-hidden">
              <div class="h-full rounded-full transition-all"
                [ngClass]="usageBarClass(siteUsedPercent(row))"
                [style.width.%]="siteUsedPercent(row)"></div>
            </div>
            <p class="text-[11px] text-slate-400 mt-1">
              เหลือออกบัตรได้อีก {{ row.quotaApproved - row.quotaUsed | number:'1.0-0' }}
            </p>
          </div>
        </div>
      </section>

      <!-- Chart: top clients by cards -->
      <section class="rounded-2xl border border-slate-100 dark:border-slate-800 bg-white/95 dark:bg-slate-900/95 shadow-xl p-5">
        <div class="mb-4">
          <h2 class="text-lg font-extrabold text-slate-800 dark:text-slate-100">Client ที่ใช้บัตรมากสุด</h2>
          <p class="text-xs text-slate-400 mt-0.5">
            Top {{ dash.topClientsByCards.length || 10 }} จากจำนวนบัตรจอดฟรีที่สร้างแล้ว — ไม่ใช่ยอดแจกโควต้า
          </p>
        </div>

        <div *ngIf="dash.topClientsByCards.length === 0" class="py-12 text-center text-slate-400">
          ยังไม่มีบัตรจอดฟรีในขอบเขตนี้
        </div>

        <div *ngIf="dash.topClientsByCards.length" class="space-y-3">
          <div *ngFor="let row of dash.topClientsByCards; trackBy: trackTop; let i = index"
            class="group">
            <div class="flex items-center justify-between gap-2 mb-1">
              <p class="font-bold text-slate-800 dark:text-slate-100 truncate min-w-0">
                <span class="text-slate-400 font-mono text-xs mr-1.5">#{{ i + 1 }}</span>
                {{ row.clientName || ('Client #' + row.clientId) }}
              </p>
              <p class="text-xs font-mono shrink-0 text-slate-600 dark:text-slate-300">
                <span class="font-black text-slate-800 dark:text-slate-100">{{ row.cardCount }}</span>
                บัตร
                <span class="text-slate-400">({{ row.sharePercent }}%)</span>
              </p>
            </div>
            <div class="h-3.5 rounded-full bg-slate-100 dark:bg-slate-800 overflow-hidden">
              <div class="h-full rounded-full bg-sky-500/90 group-hover:bg-sky-500 transition-all"
                [style.width.%]="clientBarWidth(row)"></div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <p class="mt-6 text-xs text-slate-400 text-center">
      ต้องการแจกโควต้า →
      <a routerLink="/card-quota/building-free-quota" class="text-amber-600 font-bold hover:underline">แจกสิทธิ์โควต้าจอดฟรี</a>
      · ตั้ง pool ลาน →
      <a routerLink="/system-settings/site-free-quota" class="text-amber-600 font-bold hover:underline">โควต้าจอดฟรี (ลาน)</a>
    </p>
  </ng-container>
</div>
